import { render } from "./SubjectAndSubsubject.vue?vue&type=template&id=591e81b8&ts=true"
import script from "./SubjectAndSubsubject.vue?vue&type=script&lang=ts"
export * from "./SubjectAndSubsubject.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__